
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import SearchBar from './SearchBar';
import { Clock, RefreshCw } from 'lucide-react';

interface TableHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  lastUpdateTime: string;
  onRefresh?: () => void;
  isRefreshing?: boolean;
  extraControls?: React.ReactNode;
  lastSearches?: string[];
}

const TableHeader: React.FC<TableHeaderProps> = ({
  searchQuery,
  setSearchQuery,
  lastUpdateTime,
  onRefresh,
  isRefreshing = false,
  extraControls,
  lastSearches = []
}) => {
  return (
    <CardHeader className="bg-white dark:bg-gray-900 pb-3 border-b border-slate-100 dark:border-gray-800 sticky top-0 z-30 p-3">
      <CardTitle className="flex justify-between items-center text-primary">
        <span className="flex items-center text-base">
          Danh sách đăng ký
        </span>
        <div className="flex items-center gap-2">
          {lastUpdateTime && (
            <span className="text-xs flex items-center text-muted-foreground bg-white/80 dark:bg-gray-800/80 px-2 py-0.5 rounded-full shadow-sm border border-slate-200 dark:border-gray-700">
              <Clock size={10} className="mr-1 text-primary/70" />
              {lastUpdateTime}
            </span>
          )}
          {onRefresh && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-6 w-6 p-0 rounded-full hover:bg-white/90 dark:hover:bg-gray-800/90"
              onClick={onRefresh}
              disabled={isRefreshing}
            >
              <RefreshCw 
                size={11} 
                className={`text-primary/70 ${isRefreshing ? 'animate-spin' : ''}`}
              />
            </Button>
          )}
        </div>
      </CardTitle>
      <div className="flex flex-wrap gap-2 mt-2 justify-between">
        <div className="flex-1 relative z-20">
          <SearchBar 
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            placeholder="Tìm kiếm theo tên, email, SĐT hoặc mã..."
            sticky={true}
            lastSearches={lastSearches}
          />
        </div>
        {extraControls && (
          <div className="flex items-center">
            {extraControls}
          </div>
        )}
      </div>
    </CardHeader>
  );
};

export default TableHeader;
